import React, {
  useEffect,
  useRef,
  useCallback
} from 'react';
import { unmount } from 'redom';
import {
  ReactEditor,
  useSlateStatic
} from 'slate-react';

import HelptapEditor from '../../helpers';
import BaseElement from '../base';

import Directory from './native';

import './index.scss';

function DirectoryNode(props) {

  const element = props.element;
  const editor = useSlateStatic();
  const elementPath = ReactEditor.findPath(editor, element);

  const containerReference = useRef(null);
  const directoryReference = useRef(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onInitialize = useCallback(function onInitialize(result) {
    HelptapEditor.directory.initialize(editor, element, elementPath, {
      collectionViewId: result.collectionViewId,
      initialized: true
    });
  });

  useEffect(function onElement() {

    if (containerReference.current === null) {
      return function noop() {

      };
    }

    return mountGrid({
      nodeId: element.properties.id,
      pageId: props.parentEntityId,
      collectionId: element.properties.collectionId,
      collectionViewId: element.properties.collectionViewId,
      initialized: element.properties.initialized,
      onInitialize
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containerReference.current]);

  useEffect(function onElementChange() {

    directoryReference.current.update({
      nodeId: element.properties.id,
      pageId: props.parentEntityId,
      collectionId: element.properties.collectionId,
      collectionViewId: element.properties.collectionViewId,
      initialized: element.properties.initialized
    });

  }, [element.properties.updatedAt]);

  function mountGrid(data) {

    const container = containerReference.current;

    const directory = new Directory(data);

    directoryReference.current = directory;

    container.prepend(directory.el);

    directory.onmount();

    return function onUnload() {

      unmount(container, directory);

    };

  }

  function renderDirectory() {

    const { attributes, children } = props;

    const containerAttributes = {
      ...attributes,
      className: 'directory-wrapper'
    };
    return (
      <div {...containerAttributes}>
        <div className="directory-container" ref={containerReference}></div>
        {children}
      </div>
    );
  }

  function renderMain() {
    const baseElementProperties = {
      ...props,
      customNodeControls: []
    };

    return (
      <BaseElement {...baseElementProperties}>
        {renderDirectory()}
      </BaseElement>
    );
  }

  return renderMain();
}

export default DirectoryNode;